<template>
  <div class="wrapper signup-page-wrp">
    <section v-if="step == 1">
      <div class="wrapper signup-page-wrp">
        <div class="signup-page ">
          <div class="signup-page-left">
            <div class="align">
              <h1>Verification</h1>
              <p>Enter the 4-digit code</p>
            </div>
          </div>
          <div class="signup-page-right">
            <div class="align">
              <div class="signin-form ">
                <div class="step-holder">
                  <div class="tab-heading">
                    <h1>Sign Up</h1>
                  </div>
                  <div class="stepper-wrapper">
                    <div class="stepper-item active complete">
                      <div class="step-counter"></div>
                      <div class="step-name">3. Email</div>
                    </div>
                    <div class="stepper-item active complete">
                      <div class="step-counter"><i class="ico ico-mobile"></i></div>
                      <div class="step-name">4. Verification</div>
                    </div>
                  </div>

                  <!-- Step 1 -->
                  <div class="steps ">
                    <div class="verification text-center">
                      <p>A verification code has been sent to</p>
                      <a href="javascript:void(0)">{{ form.email }}</a>
                      <p>{{ form.phone }}</p>
                    </div>
                    <div class="form-row phone-step">
                      <ul class="otp-code" id="autojump">
                        <li>
                          <div class="input-wrapper  form-wrap-cus">
                            <input type="tel" v-on:keyup="nextSwitchFunc" @keyup.delete="triggerDBKey" @paste="onPaste" ref="otp1" data-otp="1"
                                   class="form-control form-control-lg" maxlength="1" v-model="verification_code[0]">
                          </div>
                        </li>
                        <li>
                          <div class="input-wrapper form-wrap-cus">
                            <input type="tel" v-on:keyup="nextSwitchFunc" @keyup.delete="triggerDBKey" ref="otp2" data-otp="2"
                                   class="form-control form-control-lg" maxlength="1" v-model="verification_code[1]">
                          </div>
                        </li>
                        <li>
                          <div class="input-wrapper form-wrap-cus">
                            <input type="tel" v-on:keyup="nextSwitchFunc" @keyup.delete="triggerDBKey" ref="otp3" data-otp="3"
                                   class="form-control form-control-lg" maxlength="1" v-model="verification_code[2]">
                          </div>
                        </li>
                        <li>
                          <div class="input-wrapper form-wrap-cus">
                            <input type="tel" v-on:keyup="nextSwitchFunc" @keyup.delete="triggerDBKey" ref="otp4" data-otp="4"
                                   class="form-control form-control-lg" maxlength="1" v-model="verification_code[3]">
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="tab-foot text-center">
                    <span class="btn btn-lg btn-block btn-primary" @click.prevent="verifyPhoneNumber"> Verify</span>
                    <router-link :to="{ name: 'login'}">
                      <span class="btn btn-lg btn-cancel ">Cancel </span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="step == 2">
      <div class="wrapper signup-page-wrp">
        <div class="signup-page ">
          <div class="signup-page-left">
            <div class="align">
              <h1>Verification</h1>
              <p>Phone Verified </p>
            </div>
          </div>
          <div class="signup-page-right">
            <div class="align">
              <form class="signin-form ">
                <div class="step-holder">
                  <div class="tab-heading">
                    <h1>Sign Up</h1>
                  </div>

                  <div class="stepper-wrapper">

                    <div class="stepper-item  active complete ">
                      <div class="step-counter"><i class=" ico ico-user"></i></div>
                      <div class="step-name">1. Account</div>
                    </div>
                    <div class="stepper-item active complete">
                      <div class="step-counter"></div>
                      <div class="step-name">2. Personal</div>
                    </div>
                    <div class="stepper-item active complete">
                      <div class="step-counter"></div>
                      <div class="step-name">3. Phone Number</div>
                    </div>
                    <div class="stepper-item active complete">
                      <div class="step-counter"><i class="ico ico-mobile"></i></div>
                      <div class="step-name">4. Verification</div>
                    </div>
                  </div>


                  <!-- Step 1 -->
                  <div class="steps ">

                    <div class="verification text-center">

                      <p>Your account verified successfully</p>
                      <a href="">{{ form.email }}</a>
                      <p>{{ form.phone }}</p>

                    </div>

                    <div class="verification-msg text-center ">
                      <i class="ico ico-double-tick"></i> <br>
                      <p>Number verified</p>
                    </div>

                  </div>

                  <div class="tab-foot text-center">
                    <a @click.prevent="verified" class="btn btn-lg btn-block btn-primary"> Next</a>

                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import Multiselect from 'vue-multiselect';

export default {
  name: 'verifyCode',
  components: {VueTelInput, Multiselect},

  data() {
    return {
      form: {
        phone: null,
        email: null
      },
      step: 1,
      verification_code: [],
    }
  },

  mounted() {
    this.form.phone = this.$store.getters.getUser.phone;
    this.form.email = this.$store.getters.getUser.email;
    // console.log(this.form);
  },
  methods: {
    onPaste(evt) {
      this.verification_code = Array.from(String(evt.clipboardData.getData('text')), Number);
      return true;
    },
    verifyPhoneNumber() {
      let data = {
        phone: this.form.phone,
        email: this.form.email,
        verification_code: this.verification_code.join(''),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        fcm_token: 'web'
      };
      this.$root.$emit('activeCompoClick');

      this.$axios({
        method: 'post',
        data: $.param(data),
        url: this.$VerifyAccount,
      }).then(response => {
          if (response.data.status === 200) {
            let user = response.data.result.user;
            this.$store.commit('setUser', user);
            this.nextstep();
          } else if (response.data.status === 402) {
            alert('Verification Code is Invalid Or Expired')
          }
        }
      ).catch(error => {
        this.is_data_ready = true
      });
    },
    verified() {
      if(this.$store.getters.getUser.type==='EMPLOYEE') {
        this.$router.push({path: '/attendance/punchin'});
      }else{
        this.$router.push({name: 'company-profile'});
      }

    },
    nextstep() {
      this.step++;
    },
    previousstep() {
      this.step--;
    },
    nextSwitchFunc(e) {
      if($(e.target).attr('data-otp') == 1){
        this.$refs.otp2.focus();
      }else if($(e.target).attr('data-otp') == 2){
        this.$refs.otp3.focus();
      }else if($(e.target).attr('data-otp') == 3){
        this.$refs.otp4.focus();
      }
    },
    triggerDBKey(e) {
      if($(e.target).attr('data-otp') == 2){
        this.$refs.otp1.focus();
      }else if($(e.target).attr('data-otp') == 3){
        this.$refs.otp2.focus();
      }else if($(e.target).attr('data-otp') == 4){
        this.$refs.otp3.focus();
      }else if($(e.target).attr('data-otp') == 1){
        this.$refs.otp1.focus();
      }
    }

  }
}
</script>
